/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  PermissionManagerService,
  type UpsertPermissionDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const usePostUpsertPermission = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  setCheckedValues: (values: string[]) => void
): UseMutationResult<any | undefined, unknown, UpsertPermissionDto, unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: UpsertPermissionDto) => {
      return await handleRequest(
        PermissionManagerService.postApiCustomerApiPermissionManagerUpsertPermission(payload)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          await queryClient.invalidateQueries('getVendorFeatureSet');
          await queryClient.invalidateQueries('getFeatureSetList');
          setCheckedValues([]);
          closeModal();
          toast.success(
            <ToastComponent label='Success' message='Permissions updated successfully.' />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostUpsertPermission;
